export default __webpack_public_path__ + "0a1b701f5563c22882818c5c013aabbf.ttf";